/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Fault_RetryInputs */

const en_playbar_fault_retry = /** @type {(inputs: Playbar_Fault_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playback paused — click to retry`)
};

const es_playbar_fault_retry = /** @type {(inputs: Playbar_Fault_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducción en pausa: haz clic para reintentar`)
};

/**
* | output |
* | --- |
* | "Playback paused — click to retry" |
*
* @param {Playbar_Fault_RetryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_fault_retry = /** @type {((inputs?: Playbar_Fault_RetryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Fault_RetryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_fault_retry(inputs)
	return en_playbar_fault_retry(inputs)
});